module.exports = __webpack_public_path__ + "img/sr48_samurai01_shop.33ee74c5.png";